// extracted by mini-css-extract-plugin
module.exports = {"mod-character":"Character_mod-character__DHyF9"};